import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { WeightIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface WeightLogTableProps {
    weightLog: { date: string; weight: number; note: string }[];
}

export const WeightTable = ({ weightLog }: WeightLogTableProps) => {
    const { t } = useTranslation();

    return (
        <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold">{t("weight.weightLog.title")}</h2>
                <WeightIcon className="text-primary" size={24} />
            </div>

            <Table className="w-full">
                <TableHeader>
                    <TableRow>
                        <TableHead className="w-[20%]">{t("weight.form.date")}</TableHead>
                        <TableHead className="w-[20%]">{t("weight.form.weight")}</TableHead>
                        <TableHead className="w-[60%]">{t("weight.form.notes")}</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {weightLog &&
                        weightLog.map((entry, index) => (
                            <TableRow key={index}>
                                <TableCell>{entry.date.slice(0, 10)}</TableCell>
                                <TableCell>{entry.weight.toFixed(1)} kg</TableCell>
                                <TableCell className="break-words">{entry.note}</TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </div>
    );
};
